import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api } from "@/lib/api";

export function ProtectedRoute({ children }) {
  const [state, setState] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then(() => setState(true)).catch(() => setState(false));
  }, []);

  if (state === null)
    return <div className="min-h-screen grid place-items-center text-zinc-500" data-testid="auth-loading">Carregando…</div>;
  if (!state) return <Navigate to="/admin/login" replace />;
  return children;
}
